import { ButtonHTMLAttributes, ReactNode } from 'react';

interface VoltButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  fullWidth?: boolean;
}

export function VoltButton({ children, fullWidth = true, className = '', ...props }: VoltButtonProps) {
  return (
    <button
      className={`
        ${fullWidth ? 'w-full' : ''} py-4 px-6 rounded-lg
        bg-[var(--color-volt)] text-black
        font-display text-sm font-medium uppercase tracking-[0.15em]
        shadow-volt
        active:scale-[0.97] transition-all duration-100
        cursor-pointer
        disabled:opacity-50 disabled:cursor-not-allowed
        ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
}
